import { useEffect, useState } from 'react';
import { useGameStore } from './store';

// Layout components
import TopBar       from './components/TopBar';
import StatStrip    from './components/StatStrip';
import StockTabs    from './components/StockTabs';
import LeverageRow  from './components/LeverageRow';
import Chart        from './components/Chart';
import PositionBar  from './components/PositionBar';
import TradePanel   from './components/TradePanel';

// Overlays
import Splash           from './components/Splash';
import Toast            from './components/Toast';
import PctOverlay       from './components/PctOverlay';
import TutorialOverlay  from './components/TutorialOverlay';

// Modals
import DisclaimerModal   from './components/modals/DisclaimerModal';
import AdModal           from './components/modals/AdModal';
import BoostModal        from './components/modals/BoostModal';
import ReviveModal       from './components/modals/ReviveModal';
import DebtModal         from './components/modals/DebtModal';
import LaborSummaryModal from './components/modals/LaborSummaryModal';

// Full-screen screens
import LiquidationScreen from './components/LiquidationScreen';
import LaborScreen       from './components/LaborScreen';
import RankingScreen     from './components/RankingScreen';

export default function App() {
  const init = useGameStore((s) => s.init);
  const tick = useGameStore((s) => s.tick);
  const [splashDone, setSplashDone] = useState(false);

  useEffect(() => {
    init();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!splashDone) {
    return <Splash onDone={() => setSplashDone(true)} />;
  }

  return (
    <>
      {/* ── Main layout ── */}
      <TopBar />
      <StatStrip />
      <StockTabs />
      <LeverageRow />
      <Chart />
      <PositionBar />
      <TradePanel />
      <footer id="disclaimer">
        <div className="disclaimer-text">가상 시뮬레이터 · 실제 투자 무관 · 환전 불가</div>
        <nav className="footer-links">
          <a href="guide.html">게임 안내</a>
          <span className="dot">·</span>
          <a href="terms.html">이용약관</a>
          <span className="dot">·</span>
          <a href="privacy.html">개인정보처리방침</a>
        </nav>
      </footer>

      {/* ── Toast ── */}
      <Toast />

      {/* ── Overlays ── */}
      <PctOverlay />
      <TutorialOverlay />

      {/* ── Modals ── */}
      <DisclaimerModal />
      <AdModal />
      <BoostModal />
      <ReviveModal />
      <DebtModal />
      <LaborSummaryModal />

      {/* ── Full-screen layers ── */}
      <LiquidationScreen />
      <LaborScreen />
      <RankingScreen />
    </>
  );
}
